module.exports = "/_next/static/images/a3599a7b52a854ccc3f46e690a599f5e-phone.svg";